Px.Base = class Base {

  static make(...args) {
    return new this(...args);
  }

};

/* Simple JavaScript Inheritance
 * By John Resig http://ejohn.org/
 * MIT Licensed.
 */
// Inspired by base2 and Prototype
(function() {
  var initializing = false;
  // Regex used in optimization to only wrap functions that use _super.
  // Some browsers don't implement fn.toString() well, so just wrap all functions in that case.
  var fnTest = /xyz/.test(function() { var xyz; }) ? /\b_super\b/ : /.*/;

  // Create a new Px.Base that inherits from this class.
  Px.Base.extend = function extend_fn(extensions) {
    console.warn('Px.Base.extend is deprecated and will be removed soon');

    if (!(extensions && typeof extensions === 'object' && extensions.constructor === Object)) {
      throw new Error('Px.Base.extend expected an object, got: ' + typeof extensions);
    }

    // Instantiate a base class (but only create the instance,
    // don't run the initialize constructor)
    initializing = true;
    var prototype = new this();
    initializing = false;

    // The dummy class constructor
    var PxObject = function() {
      // All construction is actually done in the init method
      if (!initializing) {
        if (this.initialize) {
          this.initialize.apply(this, arguments);
        }
      }
    };

    // Enforce the constructor to be what we expect.
    PxObject.constructor = PxObject;

    // And make this class extendable.
    PxObject.extend = extend_fn;

    // To avoid using the new keyword. Make can be used instead.
    PxObject.make = function() {
      initializing = true;
      var newObj = new PxObject();
      initializing = false;
      newObj.constructor = PxObject;

      var prop;
      for (var prop_name in newObj) {
        prop = newObj[prop_name];
        if (prop && prop.__px_autobind) {
          newObj[prop_name] = prop.bind(newObj);
        }
      }

      if (newObj.initialize) {
        newObj.initialize.apply(newObj, arguments);
      }

      return newObj;
    };

    var bindSuper = function(name, value, _super) {
      if (typeof value === 'function' && typeof _super[name] === 'function' && fnTest.test(value)) {
        // We are overwriting an existing function.
        var wrapper_fn = function() {
          var tmp = this._super;

          // Add a new ._super() method that is the same method  but on the super-class.
          var super_wrapper = function() {
            var tmp = this._super;
            // We have to make sure that invoking _super() from a child method does not
            // recursively calls itself, so if we detect that this._super points to
            // the current function, we temporarily set it to undefined.
            if (tmp === super_wrapper) {
              this._super = undefined;
            }
            var ret = _super[name].apply(this, arguments);
            this._super = tmp;
            return ret;
          };
          this._super = super_wrapper;

          // The method only need to be bound temporarily, so we remove it when we're done executing.
          var ret = value.apply(this, arguments);
          this._super = tmp;

          return ret;
        };
        if (value.__px_autobind) {
          wrapper_fn.__px_autobind = true;
        }
        return wrapper_fn;
      } else {
        return value;
      }
    };

    var base = this;
    var _super = this.prototype;
    var value;
    var wrapper_fn;

    // Copy over any base class custom class properties/methods, but skip 'make' and 'constructor'
    // as those are special.
    for (var prop in base) {
      if (base.hasOwnProperty(prop)) {
        if (prop !== 'make' && prop !== 'constructor') {
          PxObject[prop] = base[prop];
        }
      }
    }

    // Copy the properties over onto the new prototype.
    for (var name in extensions) {
      value = extensions[name];

      if (name === 'class_extensions') {
        for (var cname in extensions[name]) {
          PxObject[cname] = bindSuper(cname, extensions[name][cname], base);
        }
      } else {
        prototype[name] = bindSuper(name, extensions[name], _super);
      }
    }

    // Populate our constructed prototype object.
    PxObject.prototype = prototype;

    return PxObject;
  };

})();


var Base = Px.Base;
export default Base;